export function minBigInt(a: bigint, b: bigint): bigint {
  return a < b ? a : b
}
